import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { style: {"margin-top":"15px","max-height":"400px","overflow":"auto"} }
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"12px","color":"#a8a4a0","padding":"10px 0"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { style: {"flex":"1"} }
const _hoisted_8 = { class: "cl-nm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("h3", { style: {"margin-bottom":"15px"} }, "View Checklist As", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
        placeholder: "Search by name"
      }, null, 512), [
        [_vModelText, _ctx.searchQ]
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.filteredEmployees.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No employees found."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEmployees, (e, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            onClick: ($event: any) => (_ctx.selectEmployee(e)),
            class: "cl-card",
            style: {"cursor":"pointer","margin-bottom":"8px"}
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(e.Name), 1)
            ])
          ], 8, _hoisted_6))
        }), 128))
      ])
    ])
  ]))
}